import { useTranslation } from "react-i18next";
import Input from "../../../components/form-controls/Input"
import Select from "../../../components/form-controls/Select";

function UrlBtn({ errors, register, watch, index, onDelete }) {

    const { t } = useTranslation();

    const style = watch(`buttons.buttons.${index}.style`)

    return (
        <div >
            <div className="mb-2">
                <i className={`bi bi-globe-americas text-success me-2 `} /> Ir al sitio web
            </div>
            <div className="d-flex align-items-center">
                <div className="meta-btn-container flex-grow-1 text-white-dark bg-soft-info-alternative">
                    
                    <div className="flex-grow-1 d-flex align-items-start">
                        <div className="flex-grow-1">
                            <Input
                                label={t("platform.channels.templates.text-btn")}
                                errors={errors?.text} {...register(`buttons.buttons.${index}.text`, { required: true, maxLength: { value: 25, message: '25' }, setValueAs: (value) => value.trim() })}
                                currentLength={watch(`buttons.buttons.${index}.text`).length}
                                maxLength={25}
                            />
                        </div>
                        <div className="flex-grow-1 mx-2">
                            <Select 
                                label='Tipo de URL'
                                data={[
                                    {
                                        value: 'static',
                                        text: 'Estática',
                                        disabled: false,
                                    },
                                    {
                                        value: 'dynamic',
                                        text: 'Dinámica',
                                        disabled: false,
                                    },
                                ]}
                                errors={errors}
                                {...register(`buttons.buttons.${index}.style`)}
                            />
                        </div>
                        <div className="flex-grow-1">
                            <Input
                                label={'URL del sitio web'}
                                errors={errors?.url} 
                                {...register(`buttons.buttons.${index}.url`, { required: true, maxLength: { value: 2000, message: '2000' }, setValueAs: (value) => value.trim() })}
                                currentLength={watch(`buttons.buttons.${index}.url`).length}
                                maxLength={2000}
                            />
                        </div>
                    </div>
                        
                    {
                        style === 'dynamic' && (
                            <div className="my-3 alert alert-warning">
                                Al agregar una url dinámica, solo se puede agregar una variable al final de una URL, esto creará un enlace personalizado para que el cliente vea su información.
                            </div>
                        )
                    }
                    {
                        style === 'dynamic' && (
                            <div className="mt-3">
                                <h5>Agregar URL de muestra</h5>
                                <p>
                                    Para ayudarnos a revisar tu plantilla de mensaje, agrega un ejemplo de la variable al final de la URL 
                                </p>

                                <p className="font-black">
                                    {watch(`buttons.buttons.${index}.url`)}{`{{1}}`}.
                                </p>

                                <div className="d-flex align-items-center mb-2">
                                    <label className="form-label mx-3" >{`{{1}}`}</label>
                                    <div className="flex-grow-1">
                                        <Input
                                            errors={errors?.example } {...register(`buttons.buttons.${index}.example`, { required: true })}
                                            sizeClass='form-control-sm'
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>

                <div>
                    <button type="button" className="btn btn-ghost-danger btn-icon" onClick={onDelete}><i className="bi-x-lg"></i></button>
                </div>
            </div>
            <hr className="my-3" />
        </div>
    )
}
export default UrlBtn